import authService from '@/modules/auth/services/authService'
import { Route } from 'vue-router'
import * as firebase from 'firebase/app'
import 'firebase/auth'

export default () => {
  return (to: Route, from: Route, next: Function) => {
    if (to.meta.requiresLoggedIn && !firebase.auth().currentUser) {
      next(authService.loginPath(to))
    } else if (to.name === 'login' && firebase.auth().currentUser) {
      next(authService.mainPath(to))
    } else {
      next()
    }
  }
}
